module.exports = __webpack_public_path__ + "static/media/hunters-race-MYbhN8KaaEc-unsplash.6801f6bd.jpg";